// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__1DFTZ","approved":"Status_approved__30toP","rejected":"Status_rejected__1AVix","expired":"Status_expired__3OpQ3","label":"Status_label__1Zlb1"};